// extracted by mini-css-extract-plugin
export default {"container":"PreviousQuestions_container__XEFtp","tab":"PreviousQuestions_tab__pbhdV","selected":"PreviousQuestions_selected__07MoO","content":"PreviousQuestions_content__I6SW8"};